module.exports = __webpack_public_path__ + "static/media/S3N11.d11be9f5.svg";